import { render, staticRenderFns } from "./catDatatable.vue?vue&type=template&id=3a3c221c&"
import script from "./catDatatable.vue?vue&type=script&lang=js&"
export * from "./catDatatable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports